import Layout from '@/layout';
var newOrderRouter = {
  path: '/order',
  component: Layout,
  redirect: '/order/index',
  name: 'order',
  alwaysShow: true,
  meta: {
    title: '订单管理',
    icon: 'clipboard'
  },
  children: [
  // {
  //     path: 'all-order',
  //     component: (resolve) => require(['@/views/my-create/order-management/all-order/index.vue'], resolve),
  //     name: 'all-order',
  //     meta: { title: '全部订单', icon: '' }
  // },
  {
    path: 'index',
    component: function component() {
      return import('@/views/order/index');
    },
    name: 'OrderIndex',
    meta: {
      title: '全部订单'
    }
  }, {
    path: 'order-details',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/order-details/index.vue'], resolve);
    },
    name: 'order-details',
    meta: {
      title: '订单明细',
      icon: ''
    }
  }, {
    path: 'complaint-management',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/complaint-management/index.vue'], resolve);
    },
    name: 'complaint-management',
    meta: {
      title: '投诉管理',
      icon: ''
    }
  }, {
    path: 'refund-management',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/Refund-management/index.vue'], resolve);
    },
    name: 'refund-management',
    meta: {
      title: '退款管理',
      icon: ''
    }
  }, {
    path: 'return-management',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/return-management/index.vue'], resolve);
    },
    name: 'return-management',
    meta: {
      title: '退货管理',
      icon: ''
    }
  }, {
    path: 'remind-delivery',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/remind-delivery/index.vue'], resolve);
    },
    name: 'remind-delivery',
    meta: {
      title: '提醒发货',
      icon: ''
    }
  }, {
    path: 'evaluation-management',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/evaluation-management/index.vue'], resolve);
    },
    name: 'evaluation-management',
    meta: {
      title: '评价管理',
      icon: ''
    }
  }, {
    path: 'invoice-management',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/invoice-management/index.vue'], resolve);
    },
    name: 'invoice-management',
    meta: {
      title: '发票管理',
      icon: ''
    }
  }, {
    path: 'management-standard',
    component: function component(resolve) {
      return require(['@/views/my-create/order-management/management-standard/index.vue'], resolve);
    },
    name: 'management-standard',
    meta: {
      title: '平台管理规范',
      icon: ''
    }
  }, {
    path: 'reasons',
    component: function component(resolve) {
      return require(['@/views/order/reasons.vue'], resolve);
    },
    name: 'reasons',
    meta: {
      title: '退款原因',
      icon: ''
    }
  }]
};
export default newOrderRouter;